import { useLocation, useNavigate } from "react-router";
import { useJobs } from "@/api/hooks";
import { parseJobId, switchJobPath, tokenLabel } from "@/lib/jobs";
import { useCurrentJob } from "@/state/job";

/** `fill`: takes the free width of the phone top bar's row instead of a capped one. */
export function JobSwitcher({ fill = false }: { fill?: boolean }) {
  const jobs = useJobs();
  const current = useCurrentJob();
  const navigate = useNavigate();
  const location = useLocation();
  const d = jobs.data?.data;
  return (
    <select
      className={
        fill
          ? "ctl topbar-ctl min-w-0 flex-1 truncate"
          : "ctl w-auto max-w-28 shrink-0 truncate @min-[1000px]:max-w-36 @min-[1200px]:max-w-56"
      }
      value={current.id ?? ""}
      onChange={(e) => {
        const ref = parseJobId(e.target.value);
        if (ref) void navigate(switchJobPath(ref, location.pathname));
      }}
      aria-label="job"
      title="job"
    >
      <option value="" disabled>
        {jobs.isLoading ? "loading jobs…" : "select a job"}
      </option>
      {d?.tokens.map((j) => (
        <option key={j.id} value={j.id}>
          {tokenLabel(j)}
        </option>
      ))}
      {d?.liquidity.map((j) => (
        <option key={j.id} value={j.id}>
          liquidity · {j.chain}
        </option>
      ))}
      {d?.hooks
        .filter((j) => j.available)
        .map((j) => (
          <option key={j.id} value={j.id}>
            hooks · {j.chain}
          </option>
        ))}
    </select>
  );
}
